import '@mfe'; import("./index.tsx");